import BranchesPreview from "@/components/Branches";
import BrandStamp from "@/components/BrandStamp";

export default function BranchesPage() {
  return (
    <div>
      <section className="bg-[#2D181A] text-[#FFFDF8]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-20 md:py-28">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-bold">
            Branches · शाखाएं
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-4 leading-[1.02] max-w-4xl">
            Two locations in Gurgaon.
            <br />
            <span className="italic text-[#D4AF37]">
              North India
            </span>{" "}
            home visits.
          </h1>
          <p className="mt-6 text-base md:text-lg text-[#FFFDF8]/80 leading-relaxed max-w-3xl">
            Both branches offer live karat testing, calibrated weighing and
            instant payout — cash or bank. Walk in during working hours or
            call ahead for larger consignments.
          </p>
        </div>
      </section>
      <BrandStamp variant="gold" tagline={<>Jacubpura · Sapphire Mall Sec 49 · Home Visits</>} />
      <BranchesPreview full />
    </div>
  );
}
